const MIN_LENGTH = 6

export default function(s) {
    return s != null && typeof s === 'string' && s.length >= MIN_LENGTH
}
